import axios from "axios";
import urls from "../config/urls.json";
import { isColl, isLocal } from "../services/env";
import { executeCall } from "@monforte/resilienza-package";
import moment from "moment";
import mock from "../config/mocks.json";
import { trackServiceCall } from "../lib/otel";

export const ApiService = () => {};

const getBaseUrl = (endpoint) => {
    if (isLocal()) {
        return urls[endpoint].local;
    } else if (isColl()) {
        return urls[endpoint].coll;
    } else {
        return urls[endpoint].prod;
    }
};

const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
};

const calcDist = (lat1, lon1, lat2, lon2) => {
    const toRad = (Value) => {
        return (Value * Math.PI) / 180;
    };
    var R = 6371; // km
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var lat1 = toRad(lat1);
    var lat2 = toRad(lat2);

    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};

// @mock
const _response = (endpoint, payload = {}, mockResponse) => {
    return new Promise((res, rej) => {
        setTimeout(() => {
            res(mockResponse);
        }, 500);
    });
};

const response = (endpoint, payload = {}, method = "post") => {
    let headers = {
        headers: {
            res3: window.res3 || "",
        },
    };
    return new Promise(async (res, rej) => {
        try {
            const result = await axios[method](endpoint, { ...payload, versione: "FA3" }, headers);
            if (result.status != 200) {
                rej(result.message);
            } else {
                res(result.data);
            }
        } catch (error) {
            rej(error);
        }
    });
};

/* === SERVICES === */

ApiService.getCoordsByCap = (cap) => {
    return response(`${getBaseUrl("getCoordsByCap")}${cap}`, {}, "get");
};

const addBusinessDays = (originalDate, numDaysToAdd) => {
    const Sunday = 0;
    const Saturday = 6;
    let daysRemaining = numDaysToAdd;

    const newDate = originalDate.clone();

    while (daysRemaining > 0) {
        newDate.add(1, "days");
        if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
            daysRemaining--;
        }
    }

    return newDate;
};

const getTrovaFilialiResponse = (result) => {
    const rawData = { ...result };
    const filiali = [];

    for (let filiale of rawData.filiali) {
        const filialeObj = {
            codFiliale: filiale.codice,
            nomeFiliale: filiale.ragioneSociale,
            indirizzo: filiale.indirizzo,
            cap: filiale.cap,
            citta: filiale.citta,
            provincia: filiale.provincia,
            coordinate: {
                lat: filiale.latitudine,
                lng: filiale.longitudine,
            },
            days: [],
            orarioMattina: filiale.orarioMattina,
            orarioPomeriggio: filiale.orarioPomeriggio,
        };
        if (null != filiale.disponibilita) {
            filialeObj["orariDisponibili"] = [];

            for (let [index, disp] of filiale.disponibilita.entries()) {
                filialeObj["days"].push({
                    data: disp.date,
                    disponibilita: null,
                });

                if (disp.slots && index == 0) {
                    for (let slot of Object.entries(disp.slots)) {
                        filialeObj["orariDisponibili"].push({
                            id: slot[1][0],
                            disponibile: slot[1][1],
                            label: slot[0],
                        });
                    }
                }
            }
        }
        filiali.push(filialeObj);
    }

    return {
        ...rawData,
        ricontatto: false,
        filiali,
    };
};

ApiService.TrovaFiliale = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("TrovaFiliale")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "MPS_FA",
            data: { ...payload },
            success: (result) => {
                const data = result.data || result;
                if (data == null || data.latitude == null || data.longitude == null) {
                    rej(new Error("TrovaFiliale: coordinate mancanti"));
                    return;
                }
                res(data);
            },
            error: (error) => {
                rej(error);
            },
        });
    });
};

ApiService.TrovaFiliali3 = (payload) => {
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 15000,
            url: `${getBaseUrl("TrovaFiliali3")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "MPS_FA",
            data: { ...payload, TipoFiliali: 0, versione: "FA3" },
            success: (result) => {
                const rawData = getTrovaFilialiResponse(result.data);
                res(rawData);
            },
            error: () => {
                axios
                    .post(`${getBaseUrl("TrovaFilialiFallback")}`)
                    .then(async (response) => {
                        let filialiArr = response.data;
                        filialiArr = getTrovaFilialiResponse(filialiArr.data);
                        filialiArr = filialiArr.filiali.map((f) => {
                            const dist = calcDist(payload.latitude, payload.longitude, f.coordinate.lat, f.coordinate.lng);
                            f.Distanza = dist;
                            return f;
                        });
                        filialiArr.sort((a, b) => {
                            if (a.Distanza < b.Distanza) {
                                return -1;
                            }
                            return 1;
                        });

                        filialiArr = filialiArr.map((f) => {
                            const newFiliale = {
                                ...f,
                                days: [
                                    {
                                        data: `${addBusinessDays(moment(), 1).format("YYYY-MM-DD")}T00:00:00`,
                                        disponibilita: null,
                                    },
                                    {
                                        data: `${addBusinessDays(moment(), 2).format("YYYY-MM-DD")}T00:00:00`,
                                        disponibilita: null,
                                    },
                                    {
                                        data: `${addBusinessDays(moment(), 3).format("YYYY-MM-DD")}T00:00:00`,
                                        disponibilita: null,
                                    },
                                ],
                            };

                            newFiliale["orariDisponibili"] = mock.orariDisponibiliList;

                            return newFiliale;
                        });

                        console.log("ko", filialiArr.slice(0, 2));

                        res({
                            filiali: filialiArr.slice(0, 5),
                        });
                    })
                    .catch(() => {
                        res(mock.Filiali3Fallback);
                    });
            },
        });
    });
};

ApiService.GetFiliale = (payload, currFiliale = null) => {
    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("GetFiliale")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "MPS_FA",
            data: { ...payload },
            success: (result) => {
                const rawData = getTrovaFilialiResponse({ filiali: [result.data] });
                res(rawData.filiali[0]);
            },
            error: (error) => {
                const newFiliale = {
                    ...currFiliale,
                    days: [
                        {
                            data: `${addBusinessDays(moment(), 1).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                        {
                            data: `${addBusinessDays(moment(), 2).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                        {
                            data: `${addBusinessDays(moment(), 3).format("YYYY-MM-DD")}T00:00:00+02:00`,
                            disponibilita: null,
                        },
                    ],
                };

                newFiliale["orariDisponibili"] = mock.orariDisponibili;

                res(newFiliale);
            },
        });
    });
};

const getDisponibilitaResponse = (result) => {
    const rawData = { ...result };

    const filialeObj = { orariDisponibili: [] };
    for (let slot of Object.entries(rawData.slots)) {
        filialeObj["orariDisponibili"].push({
            id: slot[1][0],
            disponibile: slot[1][1],
            label: slot[0],
        });
    }

    return filialeObj;
};

ApiService.Disponibilita = async (payload) => {
    // const result = await _response(``, { ...payload, TipoFiliali: 0 }, mock.mpsDisponibilita);
    // return getDisponibilitaResponse(result);

    return new Promise(async (res, rej) => {
        executeCall({
            url: `${getBaseUrl("Disponibilita")}`,
            method: "POST",
            retry: false,
            app: "FA3",
            flow: "MPS_FA",
            data: {
                Codice: payload.CodFiliale,
                Data: payload.Giorno,
            },
            success: function (result) {
                res(getDisponibilitaResponse(result.data));
            },
            error: function (error) {
                res(
                    getDisponibilitaResponse({
                        slots: mock.orariDisponibili,
                    })
                );
            },
        });
    });
};

ApiService.CreateAppointment = async (payload) => {
    // return _response(``, payload, mock.mpsCreateAppointment);
    return new Promise(async (res, rej) => {
        executeCall({
            timeout: 60000,
            url: `${getBaseUrl("CreateAppointment")}`,
            method: "POST",
            retry: 10,
            app: "FA3",
            flow: "PP",
            data: {
                ...payload,
                clientID: localStorage.getItem("clientID") || getCookie("_ga") || "",
                sessionID: localStorage.getItem("sessionID") || "",
                gclid: localStorage.getItem("gclid") || "",
                privacyInterncommoffer: "1",
            },
            success: (d) => {
                res(d);
            },
            error: () => {
                res({
                    oppID: "SA-1852803",
                    Status: 0,
                    Message: "OK",
                });
            },
        });
    });
};

/* === OTel: durata e errori delle chiamate ai servizi ===
   Avvolge ogni metodo di ApiService per misurare la durata di ogni chiamata
   (successo o errore) e inviarla come histogram, emettendo service_error
   quando la promise viene rifiutata. Stesso wrapper usato su fa3.2. */
Object.keys(ApiService).forEach((serviceName) => {
    const originalMethod = ApiService[serviceName];
    ApiService[serviceName] = (...args) => trackServiceCall(serviceName, originalMethod(...args));
});
